import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "../../css/course-page.css";
import "../../css/main-mobile-view.css";
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import Courseschedule from '../Landing/Subcomponent/courseschedule';

class DataEng extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol className="breadcrumb def-z course-m">
                        <li className="breadcrumb-item"><Link href="#"> <i className="icon-home"></i>HOME </Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Post Graduate Program in Data Engineering</li>
                    </ol>
                </div>
                <section className="course-header bg-yellow11" id="course-header">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg">
                            <h1>Post Graduate Program in <br />Data Engineering </h1> <br />
                            <p>Accelerate your Career. Stay Ahead of the Curve </p>
                            <br />
                            <br /><br />
                            <div className="form-group">
                                <a href="#subcribeplan" className="btn btn-md enroll-btn">Enroll Now </a>
                                <button type="button" className="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal"  >Download
                                      brochure</button><br /> <br />
                                <h3> Online Live Training</h3><br /> <br />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                            <br />
                            <p>Jointly Delivered by </p>
                            <br />
                            <div className="row">
                                <div className="col-sm-5">
                                    <img alt="executive" width="" src="/assets/images/isi.svg" />
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="col-sm-5">
                                    <img alt="executive2" width="" src="/assets/images/epn.svg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="course-main-contains def-z">
                    <div className="card">
                        <div className="row contanint-display">
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i className="fa fa-calendar" ></i>&nbsp;&nbsp;&nbsp;3 MONTHS <br />
                                    <i className="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>
                            </div>
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i className="fa fa-calendar" ></i>&nbsp;&nbsp;&nbsp;4 MONTHS<br />
                                    <i className="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKEND BATCH</b>
                            </div>
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i className=" fa fa-calendar-o" ></i> &nbsp;&nbsp;&nbsp;WEEKDAY&nbsp; (MON - FRI)<br />
                                    <i className=" fa fa-calendar-o" ></i>&nbsp;&nbsp;&nbsp;WEEKEND&nbsp; (SAT - SUN)</b>

                            </div>
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-12" id="Description">  <hr />
                                <span className="golden">Training Mode(Online)</span><br />
                                <b> <span className="font-for-batch"><i className="fa fa-calendar-o" aria-hidden="true"></i>  Date :28<sup>th</sup> Feb 2021-30<sup>th</sup> May 2021 </span></b> <br />
                                <b><span className="font-for-batch"><i className="fa fa-film" aria-hidden="true"></i>  Batch Type :Saturday-Sunday </span></b>

                            </div>
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-12">   <hr />
                                <span className="golden">Training Mode(Online)</span><br />
                                <b> <span className="font-for-batch"><i className="fa fa-calendar-o" aria-hidden="true"></i>  Date :22<sup>nd</sup> Feb 2021-14<sup>nd</sup> May 2021</span></b> <br />
                                <b><span className="font-for-batch"><i className="fa fa-film" aria-hidden="true"></i>  Batch Type :Monday-Friday </span></b>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <section className="def-z" id="Description">
                    <div className="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Industry">Industry Trends</a></li>
                            <li><a href="#tools">Tools</a></li>
                            <li><a href="#syllabus">Syllabus</a></li>
                            <li><a href="#Certification">Certification</a></li>
                            <li><a href="#Outcomes">Learning Outcomes</a></li>
                            <li><a href="#Schedule">Schedule</a></li>
                            <li><a href="#FAQs">FAQs</a></li>
                            <li className="btn-header cs-dx"><a href="#subcribeplan">Enroll Now</a> </li>
                        </ul>
                    </div>
                </section>

                <section className="course-description" id="course-description">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3>Description</h3>
                            <p align="justify" className="Descriptionbold">The Post Graduate Program in Data Engineering is jointly created & delivered by Indian Statistical Institute, Pune and edu plus now along with industry experts.</p>
                            <p align="justify"> Our tailor-made curriculum includes SQL, Mongodb, Bigdata Hadoop, Cloud, Python, Spark etc. which will help you acquire in-demand skills and start a career as an accomplished data engineer professional.</p>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-sm-12">
                            <h5>Highlights</h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            <table className="table-highlight">
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl7.svg" />  Separate batches for working professional</td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience4" src="/assets/images/icons/hl1.svg" /> Advisory Board members from Industry & Academia </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience5" src="/assets/images/icons/hl2.svg" /> Capstone Project spanning throughout the course
                              duration
                           </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience6" src="/assets/images/icons/hl3.svg" /> Industry-Endorsed Curriculum </td>
                                </tr>
                            </table>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <table className="table-highlight">
                                <tr>
                                    <td> <img alt="datascience7" src="/assets/images/icons/hl4.svg" />  Aptitude and Soft Skills Development </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience8" src="/assets/images/icons/hl5.svg" /> Leading Technical Faculty with Domain Expertise </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience9" src="/assets/images/icons/hl6.svg" /> Placement Assistance</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <br />
                    <div className="row ">
                        <div className="col-sm-6">
                            <h5> Who Should Enroll? </h5>
                            <ul className="admission-ul">
                                <li> Fresh graduates with interest in Data Science, Machine Learning and AI</li>
                                <li id="Industry"> Working professionals / managers and above who would need to extract information from data that they routinely encounter from areas such as Retail, Banking, BPO, IT, Sales & Marketing, Supply chain, Strategic management, etc.</li>
                                <li> Software Programmers </li>
                                <li>Marketing and Sales Professionals</li>
                                <li> Individuals interested in Data Science</li>
                            </ul>
                        </div>
                        <div className="col-sm-6">
                            <h5> Eligibility </h5>
                            <ul className="admission-ul">
                                <li> All Graduates / Post Graduates – Engineering, IT, Computer Science, Mathematics, Statistics, Actuarial Science, Economics, Life Science, Electronics</li>
                                <li>MBA All Streams</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section className="course-industry-trends bg-secondary" id="course-industry-trends">
                    <div className="row">
                        <div className=" col-md-6 col-sm-12">
                            <h3> Industry Trends </h3>
                            <br />
                            <h5>Job Roles</h5>
                            <ul className="industry-trends-ul">
                                <li>Data Analyst </li>
                                <li>Data Engineer </li>
                                <li>Data Scientist </li>
                                <li>Business Analyst </li>
                                <li id="tools">Machine Learning Engineer </li>
                            </ul>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <img alt="datascience11" src="/assets/images/icons/industry-trends.svg" />
                        </div>
                    </div>
                </section>
                <br />
                <section className="course-tools-covered" id="course-tools-covered">
                    <h3> Tools Covered </h3>
                    <br />
                    <div className="owl-carousel owl-theme" id="owl-carousel-course-tools">
                        <div className="item">
                            <div className="card">
                                <center id="syllabus"> <img alt="datascience12" src="/assets/images/icons/hadoop-logo.png" /></center>
                            </div>
                        </div>
                        <div className="item">
                            <div className="card" >
                                <center><img alt="datascience13" src="/assets/images/icons/spark-scala-logo.png" /> </center>
                            </div>
                        </div>
                        <div className="item">
                            <div className="card" >
                                <center><img alt="datascience16" src="/assets/images/icons/python-logo.svg" /> </center>
                            </div>
                        </div>
                        <div className="item">
                            <div className="card" >
                                <center><img alt="datascience24" src="/assets/images/icons/mongodb_logo1.png" /> </center>
                            </div>
                        </div>
                        <div className="item">
                            <div className="card" >
                                <center><img alt="datascience24" src="/assets/images/icons/mysql-logo.png" />  </center>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="course-syllabus" id="course-syllabus">
                    <div className="row">
                        <div className="col-sm-6 ">
                            <br />
                            <h3> Syllabus </h3>
                            <br />
                            <div className="syl-bg">
                                <h5>Data Engineering </h5>
                                <div id="de_syllabus">
                                    <div className="panel-group">
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> SQL
                                 </h6>
                                            </div>
                                            <div id="de_syllabus1" className="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li> SQL Overview </li>
                                                        <li> SQL SELECT Statements </li>
                                                        <li> SQL Functions and Expressions </li>
                                                        <li> SQL Updating </li>
                                                        <li> SQL Sub Queries and Unions </li>
                                                        <li> SQL Summarization </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Hadoop
                                 </h6>
                                            </div>
                                            <div id="de_syllabus2" className="collapse show" aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li> Hadoop Architecture</li>
                                                        <li> Basic Features: HDFS Data
                                                        Characteristics
                                       </li>
                                                        <li> Map Reduce Architecture</li>
                                                        <li> HDFS Architecture</li>
                                                        <li>Hive Architecture</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> MongoDB
                                 </h6>
                                            </div>
                                            <div id="de_syllabus3" className="collapse show" aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Introduction to MongoDB</li>
                                                        <li>Introduction to NoSQL</li>
                                                        <li>Mongodb Query Document</li>
                                                        <li>Creating, Reading and Updating Data</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Spark
                                 </h6>
                                            </div>
                                            <div id="de_syllabus4" className="collapse show" aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Spark Architecture</li>
                                                        <li>RDD Fundamentals</li>
                                                        <li> Basic Scala Programming</li>
                                                        <li> Spark SQL introduction</li>
                                                        <li> Spark SQL Data frames</li>
                                                        <li> Spark Job Extraction</li>
                                                        <li> Into Spark Streaming</li>
                                                        <li> Intro to Recommendations system</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h5>Data Analytics, Machine Learning & Deep Learning</h5>
                                <div id="damldl_syllabus">
                                    <div className="panel-group">
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="damldl_heading4" data-toggle="collapse"
                                                href="#damldl_syllabus4" aria-expanded="true" aria-controls="damldl_syllabus4">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Python Programming
                                 </h6>
                                            </div>
                                            <div id="damldl_syllabus4" className="collapse show" aria-labelledby="damldl_heading4"
                                                data-parent="#damldl_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li> Variables, Data structures & Control flow</li>
                                                        <li> Functions, Procedural Approach,Modules, File Handling</li>
                                                        <li> Algorithms, Debugging & Bug Fixing </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="damldl_heading5" data-toggle="collapse"
                                                href="#damldl_syllabus5" aria-expanded="true" aria-controls="damldl_syllabus5">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Cloud - Amazon Web Services(AWS)
                                 </h6>
                                            </div>
                                            <div id="damldl_syllabus5" className="collapse show" aria-labelledby="damldl_heading5"
                                                data-parent="#damldl_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Introduction to Cloud Computing and AWS.</li>
                                                        <li>Amazon Elastic Book Store</li>
                                                        <li>Amazon Elastic Compute Cloud</li>
                                                        <li>Storage and Load Balancing, Scaling and DNS</li>
                                                        <li>Amazon Virtual Cloud</li>
                                                        <li>Amazon Elastic File System</li>
                                                        <li id="Certification">Database – RedShift</li>
                                                        <li>Code Deployment</li>
                                                        <li>Project</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div className="row">
                        <div className="col-sm-6">
                            <h3>Learning Outcomes</h3>
                            <br />
                            <ul className="lo-ul">
                                <li>Gain expertise in Data Engineering, Data Analytics Machine learning &
                                DataVisualization.
                                </li>
                                <li>Master descriptive and inferential statistics, hypothesis testing, regression analysis,
                                data blending, data extracts, and forecasting
                                </li>
                            </ul>
                            <br />
                            <h5>Assessment </h5>
                            <p align="justify" id="Schedule">
                                Periodic assessment and case studies evaluations by the Indian Statistical Institute,Pune (ISI)
                                and edu plus now have been built in throughout the duration of the course.
                            </p>
                        </div>
                        <div className="col-sm-6" >
                            <img alt="datascience18" src="/assets/images/icons/certificate-final.png" />
                            <p className="img-below-text text-center">Awarded Jointly by The Indian Statistical Institute,Pune and
                            edu plus now
                     </p>
                        </div>
                    </div>
                </section>
                <Courseschedule />
                <Aboutuslearners />
                <Aluminicompany />
                <section className="courses-feesm">
                    <section className="course-fees" id="course-fees">
                        <div className="row box-sh" >
                            <div className="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                                <br /><h6>Course Fees :<i className='fa fa-inr ' ></i><b><span id='fee-gst' > 80,000</span></b><span className='fee-gst'> (+GST)</span></h6>
                            </div>
                            <div className="vertical-line-fee"> </div>
                            <div className="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div className="row">
                                    <div className="col-sm-10"> <br />
                                        <h5>Features </h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <ul className="highlight-ss" >
                                            <li>	Indian Statistical Institute as a knowledge partner.</li>
                                            <li>	Mentorship by industry specialists.</li>
                                            <li>	Course awarded by Edu Plus Now.</li>
                                            <li>Separate batches for working professional</li>
                                            <li>Advisory Board members from Industry & Academia</li>
                                            <li>Capstone Project spanning throughout the course duration</li>
                                            <li>Industry-Endorsed Curriculum</li>
                                        </ul>
                                    </div>
                                    <p>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section className="course-about-instructor bg-secondary " id="course-about-instructor">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3>
                                About the Organization
                            </h3>
                            <br />
                            <img alt="datascience23" width="" src="/assets/images/isi-black.svg" />
                            <br /><br />
                            <p align="justify">It is a Central Government institute, devoted to research, teaching & application of
                            not only statistics and allied sciences, but also the natural sciences, social
                            sciences and their interface with the statistics. Founded by Professor P.C.
                            Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                            an Institution of National Importance by an act of the Indian Parliament in 1959.
                           </p>
                            <br />
                            <p align="justify" id="FAQs">ISI Pune is a unit of Indian Statistical Institute,Pune, active in Teaching, Training,
                            Research and Consulting on application of statistics, operations research & allied
                            science to solve problems of the industry across the spread and depth of the
                            industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                            TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                            Data Analytic, Data Science.
                            </p>
                        </div>
                    </div>
                </section>


                <section className="course-faq" id="course-faq">
               <br />
               <h3> FAQs </h3>
               <br />
               <div className="row">
                  <div className="col-sm-7 bg-secondary">
                     <br />
                     <div id="faqs">
                        <div className="panel-group">
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading1" data-toggle="collapse" href="#faqs1"
                                 aria-expanded="true" aria-controls="faqs1">
                                 <h6 className="panel-title">
                                   <i className="indicator fa fa-minus"></i>  What tools will I learn with this course?
                                 </h6>
                              </div>
                              <div id="faqs1" className="collapse show" aria-labelledby="faqs_heading1"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <p ></p>
                                    <ul className="faq-ul">
                                       <li> In this course, you will learn functional analytics, SQL, Statistical Analysis, Text Mining,
                                          Regression Modelling, Hypothesis Testing, Predictive Analytics, Machine Learning using R,
                                          Python, Deep Learning, Neural Networks, Natural Language Processing, Predictive
                                          Modelling, Tableau, Spark, Hadoop, etc. All these tools will help you acquire in-demand skills
                                          and start a career as an accomplished data scientist. 
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading2" data-toggle="collapse" href="#faqs2"
                                 aria-expanded="true" aria-controls="faqs2">
                                 <h6 className="panel-title">
                                   <i className="indicator fa fa-plus"></i> How will a course in Data Engineering benefit me?
                                 </h6>
                              </div>
                              <div id="faqs2" className="collapse" aria-labelledby="faqs_heading2"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <ul className="faq-ul">
                                       <li> The course will help you gain expertise in Data Engineering 
                                          &amp; Data Visualization. 
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading3" data-toggle="collapse" href="#faqs3"
                                 aria-expanded="true" aria-controls="faqs3">
                                 <h6 className="panel-title">
                                    <i className="indicator fa fa-plus"></i> Who are eligible for the course?
                                 </h6>
                              </div>
                              <div id="faqs3" className="collapse" aria-labelledby="faqs_heading3"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <ul className="faq-ul">
                                       <li> All Graduates / Post Graduates – Engineering, IT, Computer Science, Mathematics, Statistics,
                                          Actuarial Science, Economics, Life Science, Electronics and MBA (All Streams) are eligible for
                                          the course. 
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading4" data-toggle="collapse" href="#faqs4"
                                 aria-expanded="true" aria-controls="faqs4">
                                 <h6 className="panel-title">
                                    <i className="indicator fa fa-plus"></i> Is there a selection process?
                                 </h6>
                              </div>
                              <div id="faqs4" className="collapse" aria-labelledby="faqs_heading4"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <ul className="faq-ul">
                                       <li> There is no selection process for the course. </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading5" data-toggle="collapse" href="#faqs5"
                                 aria-expanded="true" aria-controls="faqs5">
                                 <h6 className="panel-title">
                                    <i className="indicator fa fa-plus"></i> What is the course duration?
                                 </h6>
                              </div>
                              <div id="faqs5" className="collapse" aria-labelledby="faqs_heading5"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <ul className="faq-ul">
                                       <li> The course duration is 3 months. There are two separate batches for weekdays and
                                          weekends. 
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading6" data-toggle="collapse" href="#faqs6"
                                 aria-expanded="true" aria-controls="faqs6">
                                 <h6 className="panel-title">
                                    <i className="indicator fa fa-plus"></i> Will there be tests and projects?
                                 </h6>
                              </div>
                              <div id="faqs6" className="collapse" aria-labelledby="faqs_heading6"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <ul className="faq-ul">
                                       <li> Periodic assessment and case studies evaluations by the Indian Statistical Institute,Pune (ISI) and
                                          edu plus now have been built in throughout the duration of the course. 
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading7" data-toggle="collapse" href="#faqs7"
                                 aria-expanded="true" aria-controls="faqs7">
                                 <h6 className="panel-title">
                                   <i className="indicator fa fa-plus"></i> What are the career options after this course?
                                 </h6>
                              </div>
                              <div id="faqs7" className="collapse" aria-labelledby="faqs_heading7"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <ul className="faq-ul">
                                       <li> After completing this course, you can work as Data Analyst, Data Engineer, Data Scientist,
                                          Business Analyst and Machine Learning Engineer in IT Companies, In-house analytics units of
                                          corporations, Niche analytics firms, MNC financial institutions, Pharma, Retail, Healthcare,
                                          Oil &amp; Gas Industry, Telecommunication, Insurance &amp; Manufacturing Companies. 
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading8" data-toggle="collapse" href="#faqs8"
                                 aria-expanded="true" aria-controls="faqs8">
                                 <h6 className="panel-title">
                                   <i className="indicator fa fa-plus"></i> Do you offer placement assistance?
                                 </h6>
                              </div>
                              <div id="faqs8" className="collapse" aria-labelledby="faqs_heading8"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <ul className="faq-ul">
                                       <li> We do offer placement assistance with this course. </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div className="panel panel-info">
                              <div className="panel-heading" id="faqs_heading9" data-toggle="collapse" href="#faqs9"
                                 aria-expanded="true" aria-controls="faqs9">
                                 <h6 className="panel-title">
                                   <i className="indicator fa fa-plus"></i> Will I get a certification after completing the course?
                                 </h6>
                              </div>
                              <div id="faqs9" className="collapse" aria-labelledby="faqs_heading9"
                                 data-parent="#faqs">
                                 <div className="panel-body">
                                    <ul className="faq-ul">
                                       <li> Yes. A certification is awarded Jointly by the Indian Statistical Institute,Pune and edu plus now
                                          after course completion. 
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-sm-3"> </div>
               </div>
            </section>


            </div>
        );
    }
}

export default DataEng;